import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions: sliceActions } = createSlice({
  name: 'addWorksheet',
  initialState: {
    adding: false,
    sampleId: null,
    worksheetTypeId: null,
    worksheetId: null,
  },
  reducers: {
    clearAddWorksheet: (state) => {
      state.sampleId = null;
      state.worksheetTypeId = null;
      state.worksheetId = null;
    },
    addWorksheet: (state, { payload: { sampleId, worksheetTypeId } }) => {
      state.adding = true;
      state.worksheetId = null;
      state.sampleId = sampleId;
      state.worksheetTypeId = worksheetTypeId;
    },
    addWorksheetResolve: (state, { payload: { worksheetId } = {} }) => {
      state.worksheetId = worksheetId;
      state.adding = false;
    },
    addWorksheetReject: (state) => {
      state.worksheetId = null;
      state.adding = false;
    },
  },
});

export { reducer };
export const actions = { ...sliceActions };
